import Alert from "react-bootstrap/Alert";

type ErrorAlertProps = {
    id?: string;
    children: React.ReactNode;
};

export const ErrorAlert = (props: ErrorAlertProps) => {
    const {
        id,
        children
    } = props;

    return (
        <Alert variant={"danger"} id={id}>
            {children}
        </Alert>
    );
};
